<!--<body>
  <app-nav-menu></app-nav-menu>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</body>-->

<div class=" bg-white pb-3 container">
  <app-nav-menu></app-nav-menu>
  <div id="mainBody" class="min-vh-100">
    <router-outlet></router-outlet>
  </div>
  <footer class="mat-elevation-z4">    
    <nav class="container navbar fixed-bottom navbar-light text-white" style="background-color:#cc0000">
      <div class="form-inline">Copyright © 2020 Halliburton. All Rights Reserved. <u><a style="color:white" href="https://www.halliburton.com/content/halliburton/en-US/about-us/legal/default.html?SRC=Footer" target="_blank"> Terms of Use </a></u>  |  <u><a style="color:white" href="https://www.halliburton.com/content/halliburton/en-US/about-us/legal/privacy-policy.html?SRC=Footer" target="_blank">Privacy Notice</a></u></div>
    </nav>
  </footer>
</div>
